import React, { useState } from 'react';
import { DragDropContext } from 'react-beautiful-dnd';
import { Toggle } from '@blueprintnyc/bpnyc-common-admin';
import WidgetButtons from 'components/WidgetButtons';
import WidgetDevicePreview from './WidgetDevicePreview';
import WidgetBuilderSettings from './WidgetBuilderSettings';
import WidgetUpdate from './WidgetUpdate';

const WidgetBuilder = props => {
	const {
		handleWidgetDelete,
		handleWidgetDuplicate,
		handleDragEnd,
		showUpdateOptions,
		setShowUpdateOptions,
		preview,
		isSaving,
	} = props;

	const [controls, setControls] = useState('content');

	const onDelete = (e, widgetKey) => {
		e.stopPropagation();
		handleWidgetDelete(widgetKey);
		setShowUpdateOptions(false);
	};

	const onDuplicate = (e, widgetKey) => {
		e.stopPropagation();
		handleWidgetDuplicate(widgetKey);
	};

	const showSettings = controls === 'settings';

	const handleShowControls = device => {
		setControls(device);
		setShowUpdateOptions(false);
	};

	return (
		<div className="WidgetBuilder" aria-busy={isSaving} inert={isSaving ? '' : undefined}>
			<DragDropContext onDragEnd={handleDragEnd}>
				<div
					className="WidgetPreviewContainer"
					style={{ flex: preview === 'desktop' ? 3 : preview === 'tablet' ? 1 : 0.4 }}
				>
					<WidgetDevicePreview {...props} onDelete={onDelete} onDuplicate={onDuplicate} />
				</div>
				<div className="WidgetBuilderControls">
					<Toggle
						toggleOptions={['content', 'settings']}
						value={controls}
						onChange={handleShowControls}
					/>
					{showUpdateOptions ? (
						<WidgetUpdate {...props} />
					) : showSettings ? (
						<WidgetBuilderSettings {...props} />
					) : (
						<WidgetButtons />
					)}
				</div>
			</DragDropContext>
		</div>
	);
};

export default WidgetBuilder;
